<template>
  <!-- <transition name="slide-left"> -->
  <ul
    class="toollist-bar"
    v-show="isShowAsideTool"
    :class="{ 'toollist-bar-en': language == 'en-US' }"
  >
    <li v-for="(toolArr, toolIndex) in list" :key="toolIndex" class="tool-row">
      <div v-for="(tool, index) in toolArr" :key="index" :data-type="tool.type" :data-key="tool.key" class="tool-column pointer" @click="changeToolBar(tool)">
        <img :src="tool.icon" width="18" height="21" />
        <p class="tool-name">{{ $t(`asideLeft.${tool.name}`) }}</p>
      </div>
      <div v-for="empryIndex in (3-toolArr.length)" :key="empryIndex" data-type="empty" data-key="empty" class="tool-column empty-tool">
      </div>
    </li>
  </ul>
  <!-- </transition> -->
</template>
<script>
import signIcon from "@/svg/qiandao.svg";
import luckDrawsIcon from "@/svg/choujiang.svg";
import passwordLuckDrawsIcon from "@/svg/koulingchoujiang.svg";
import answerSheetIcon from "@/svg/dati.svg";
import boardIcon from "@/svg/gonggao.svg";
import countDownIcon from "@/svg/count-down.svg";
import commodityIcon from "@/svg/shangpin.svg";
import answerIcon from "@/svg/wenjuan.svg";
import redpacketIcon from "@/svg/redpacket_tool.svg";
import recommendIcon from "@/svg/recomed.svg";
import { mapGetters } from "vuex";
import Role from "@/mixins/role";
import {getRunningPasswordRaffle} from "@/api/liveRequest/luckDawApi";

export default {
  name: "AsideSub",
  mixins: [Role],
  data() {
    return {
      toolListBar: [
        {
          name: "签到",
          type: "5_0",
          icon: signIcon,
          key: "is_check_in",
        },
        {
          name: "问卷",
          type: "5_1",
          icon: answerIcon,
          key: "is_questionnaire",
        },
        {
          name: "抽奖",
          type: "5_2",
          icon: luckDrawsIcon,
          key: "is_lottery",
        },
        {
          name: "口令抽奖",
          type: "5_3",
          icon: passwordLuckDrawsIcon,
          key: "is_lottery",
        },
        {
          name: "答题",
          type: "5_4",
          icon: answerSheetIcon,
          key: "is_answer",
        },
        {
          name: "商品",
          type: "5_5",
          icon: commodityIcon,
          key: "is_commodity",
        },
        {
          name: "公告",
          type: "5_6",
          icon: boardIcon,
          key: "is_notice",
        },
        {
          name: "计时",
          type: "5_7",
          icon: countDownIcon,
          key: "is_count_down",
        },
        {
          name: "红包",
          type: "5_8",
          icon: redpacketIcon,
          key: "is_red_packet",
        },
        {
          name: "推荐",
          type: "5_9",
          icon: recommendIcon,
          key: "is_recommend",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["isShowAsideTool", "liveRoomStatus", "liveConfig", "language"]),
    s() {
      return this.liveConfig;
    },
    list() {
      const list = [];
      const filterList = this.toolListBar.filter(
        (v) =>
          ((this.s[v.key] || v.key === "is_notice") && this.role === 3) ||
          (v.key === "is_count_down" && (this.share || this.role === 3))
      );

      for (const filterItem of filterList) {
        const lastItem = list[list.length - 1];
        if (!lastItem || lastItem.length >= 3) {
          list.push([filterItem])
          continue;
        }

        lastItem.push(filterItem);
      }

      return list;
    },
  },
  watch: {
    role(val) {
      if (val !== 3) {
        [
          "SET_SHOW_SIGN",
          "SET_SHOW_ANSWER",
          "SET_SHOW_LUCK",
          "SET_SHOW_PASSWORD_LUCK",
          "SET_SHOW_ANSWERSHEET",
          "SET_SHOW_GOODS",
          "SET_SHOW_CEMENT",
          "SET_SHOW_RED_PACKET",
          "SET_SHOW_RECOMMEND",
          "SET_SHOW_COUNT_DOWN",
        ].forEach((key) => {
          this.$store.commit(key, false);
        });
      }
    },
  },
  methods: {
    changeToolBar(tool) {
      console.log(tool.type);
      if (this.checkLive(tool.type)) return;
      switch (tool.type) {
        // 签到
        case "5_0":
          this.$store.commit("SET_SHOW_SIGN", true);
          break;
        //问卷
        case "5_1":
          this.$store.commit("SET_SHOW_ANSWER", true);
          break;
        // 抽奖
        case "5_2":
          getRunningPasswordRaffle()
            .then((res) => {
              if (res.code === 200 && res.data.length) {
                console.log('exist runningPasswordRaffle, not allow set SET_SHOW_LUCK to true');
                this.$alert(this.$t('asideLeft.当前正在进行抽奖，请结束活动后，再重新发起'), {
                  title: this.$t("App.提示"),
                  confirmButtonText: this.$t("App.我知道了"),
                })
                return;
              }

              this.$store.commit("SET_SHOW_LUCK", true);
            }).catch((err) => {
              console.error('changeToolBar SET_SHOW_LUCK to true getRunningPasswordRaffle catch err:', err);
              this.$store.commit("SET_SHOW_LUCK", true);
            })
          break;
        // 口令抽奖
        case "5_3":
          this.$store.commit("SET_SHOW_PASSWORD_LUCK", true);
          break;
        //答题
        case "5_4":
          this.$store.commit("SET_SHOW_ANSWERSHEET", true);
          break;
        // 商品
        case "5_5":
          this.$store.commit("SET_SHOW_GOODS", true);
          break;
        // 公告
        case "5_6":
          this.$store.commit("SET_SHOW_CEMENT", true);
          break;
        case "5_7":
          this.$store.commit("SET_SHOW_COUNT_DOWN", true);
          break;
        case "5_8":
          this.$store.commit("SET_SHOW_RED_PACKET", true);
          break;
        case "5_9":
          this.$store.commit("SET_SHOW_RECOMMEND", true);
          break;
        default:
          break;
      }
    },
    checkLive(type) {
      console.log(type);
      if (["5_2", "5_3", "5_6", "5_8"].includes(type)) {
        if (this.liveRoomStatus !== 2) {
          this.$message.warning(this.$t("aside-left-sub.请先开启直播"));
          return true;
        } else {
          return false;
        }
      }
      
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.toollist-bar {
  position: absolute;
  top: 10%;
  left: 0;
  width: 200px;
  z-index: 1000;
  background: #212442;
  color: #7d7f8c;
  font-size: 12px;
  transition: left 0.15s linear;
  box-sizing: border-box;
  flex-wrap: wrap;
  align-content:flex-start;
  border-radius: 6px;

  li {
    display: flex;
    .tool-column {
      flex: 1;
      padding: 10px 0;
    }
  }
}
.toollist-bar-en {
  width: 210px;
}

.slide-left-enter,
.slide-left-leave-to {
  left: -70px;
}
</style>
